import React from 'react'
import PropTypes from 'prop-types'
import InputField from '../forms/input-field'
import CtaButton from '../buttons/cta-button'

const ResetPasswordForm = props => {
  const {
    handleSubmit,
    onPasswordChange,
    onPasswordConfirmChange,
    password,
    passwordError,
    confirmPassword,
    confirmPasswordError
  } = props
  return (
    <form onSubmit={handleSubmit} action='' method=''>
      <InputField
        name='password'
        type='password'
        label='New password'
        theme='dark-theme'
        value={password}
        onChange={onPasswordChange}
        hasError={Boolean(passwordError)}
        errorText={String(passwordError)}
        autoFocus
      />
      <InputField
        name='confirmPassword'
        type='password'
        label='Confirm password'
        theme='dark-theme'
        value={confirmPassword}
        onChange={onPasswordConfirmChange}
        hasError={Boolean(confirmPasswordError)}
        errorText={String(confirmPasswordError)}
      />
      <div className='top-space bottom-space'>
        <CtaButton
          text='Reset my password'
          iconName='password'
          isLoading={props.isSending}
          disabled={Boolean(
            props.isSending || props.passwordError || props.confirmPasswordError
          )}
        />
      </div>
    </form>
  )
}

ResetPasswordForm.propTypes = {
  password: PropTypes.string,
  confirmPassword: PropTypes.string,
  passwordError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  confirmPasswordError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isSending: PropTypes.bool,
  handleSubmit: PropTypes.func,
  onPasswordChange: PropTypes.func,
  onPasswordConfirmChange: PropTypes.func
}

export default ResetPasswordForm



// WEBPACK FOOTER //
// ./src/ui/forget-password/ResetPasswordForm.js